import {tns} from 'tiny-slider/src/tiny-slider';
import axios from 'axios';
import Accordion from './Accordion';

export default class Timeline {
  constructor() {
    this.dataHolder = document.getElementsByClassName('js--timeline-project__tab__expectations');
    this.dataHolderFaq = document.getElementsByClassName('js--timeline-faq__items');
    this.buttons = document.getElementsByClassName('js-timeline-project__item');
    this.items = document.getElementsByClassName('timeline-project__item');
    this.timeline = document.querySelector('.timeline-project');
    this.tab = document.querySelector('.timeline-project__tab');
    this.activeTab = Array.from(this.buttons).findIndex((button) => button.classList.contains('timeline-project__item--active'));

    if (!this.tab && this.activeTab) return;

    this.getStatusData(this.activeTab);
    this.getStatusFaqData(this.activeTab);

    Array.from(this.buttons).forEach((button, index) => {
      button.onclick = () => {
        if (
          this.tab.classList.contains('timeline-project__tab--inactive') &&
          this.activeTab === null
        ) {
          this.activeTab = index;
          this.items[index].classList.add('timeline-project__item--selected');
          this.tab.classList.remove('timeline-project__tab--inactive');
        } else if (
          !this.tab.classList.contains('timeline-project__tab--inactive') &&
          this.activeTab !== null &&
          this.activeTab !== index
        ) {
          this.items[this.activeTab].classList.remove(
            'timeline-project__item--selected'
          );
          this.activeTab = index;
          this.items[index].classList.add('timeline-project__item--selected');
          this.getStatusData(index);
          this.getStatusFaqData(index);
        } else {
          this.tab.classList.add('timeline-project__tab--inactive');
          this.activeTab = null;
          this.items[index].classList.remove(
            'timeline-project__item--selected'
          );
        }
      };
    });

    const slider = document.querySelector('.js-slider-items');

    if (slider) {
      slider.addEventListener('slideChanged', () => {
        /** find active index */
        const activeItem = slider.querySelector('.slider__item.timeline-project__item--selected')

        if (activeItem) {
          const {loopIndex} = activeItem.dataset;

          this.getStatusData(loopIndex);
          this.getStatusFaqData(loopIndex);
        }
      })
    }
  }

  getStatusData(index) {
    if (this.dataHolder[0] && this.items[index].dataset.link) {
      const url = this.items[index].dataset.link;
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            this.dataHolder[0].innerHTML = response.data;
          }
        })
        .catch((error) => {
        });
    }
  }

  getStatusFaqData(index) {
    if (this.dataHolder[0] && this.items[index].dataset.faqlink) {
      const url = this.items[index].dataset.faqlink;
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            this.dataHolderFaq[0].innerHTML = response.data;
            // ACCORDION
            const accordionElems = document.querySelectorAll('.js-accordion');
            if (accordionElems.length) {
              Array.from(accordionElems).forEach((accordion) => {
                new Accordion(accordion);
              });
            }
          }
        })
        .catch((error) => {
        });
    }
  }
}
